import { useState, useRef } from 'react';
import { TwitterPicker } from 'react-color';
import './styles.scss';
import useOutsideClick from '../../../hook/useOutsideClick';
import cx from 'classnames';

const ColorPicker = ({ label, color, onChange, isDisabled = false, pickerWidth = '200px' }) => {
  const ref = useRef();
  const [isOpen, setIsOpen] = useState(false);

  useOutsideClick(ref, () => setIsOpen(false));

  return (
    <div className="color-picker-wrapper" ref={ref}>
      <div className="color-picker-label form-label">{label}</div>
      <div className={cx('color-picker-input', { isDisabled })} onClick={() => (isDisabled ? {} : setIsOpen(!isOpen))}>
        <div className="color-square" style={{ backgroundColor: color }}></div>
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.5 9L12.5 15L18.5 9" stroke="#101828" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      {isOpen && (
        <TwitterPicker
          colors={['#000000', '#ffffff', '#2563EB', '#059669', '#D97706', '#9333EA', '#BE123C', '#0284C7']}
          color={color}
          onChange={(color) => onChange(color)}
          triangle="hide"
        />
      )}
    </div>
  );
};

export default ColorPicker;
